export default "__VITE_ASSET__QPKcSl_x__"